type RingSizeProduct = Pick<FlattenedProduct, 'c_mHJRetailCategory' | 'c_mhj_processedSizeOptions'>

// A remembered size only applies when this ring offers it, regardless of stock.
export const getDefaultRingSize = (
  product: RingSizeProduct | null | undefined,
  rememberedSize: string | null | undefined,
): string | undefined => {
  if (!product?.c_mHJRetailCategory?.includes('Rings')) return
  const sizes = product.c_mhj_processedSizeOptions?.map((option) => option.size) ?? []
  if (sizes.length === 1) return sizes[0]
  return rememberedSize && sizes.includes(rememberedSize) ? rememberedSize : undefined
}
